"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextWithTimestampToJSON = exports.TextWithTimestampFromJSONTyped = exports.TextWithTimestampFromJSON = exports.instanceOfTextWithTimestamp = void 0;
/**
 * Check if a given object implements the TextWithTimestamp interface.
 */
function instanceOfTextWithTimestamp(value) {
    var isInstance = true;
    isInstance = isInstance && "text" in value;
    isInstance = isInstance && "startTime" in value;
    return isInstance;
}
exports.instanceOfTextWithTimestamp = instanceOfTextWithTimestamp;
function TextWithTimestampFromJSON(json) {
    return TextWithTimestampFromJSONTyped(json, false);
}
exports.TextWithTimestampFromJSON = TextWithTimestampFromJSON;
function TextWithTimestampFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'text': json['text'],
        'startTime': json['start_time'],
    };
}
exports.TextWithTimestampFromJSONTyped = TextWithTimestampFromJSONTyped;
function TextWithTimestampToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'text': value.text,
        'start_time': value.startTime,
    };
}
exports.TextWithTimestampToJSON = TextWithTimestampToJSON;
